/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { Content, Flex, TextInput, Button, TableV2 } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import { push } from 'connected-react-router';
import { getAllSystemUsers, getUserByEmail } from '../util/Interface';
import TableFooter from '../components/TableFooter';
import S from './SearchUsers.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const formatUnixTimeStamp = timeStamp => {
  const date = new Date(timeStamp);
  return date.toLocaleString();
};
function SearchUsersScreen(props) {
  const [userData, setUserData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pages, setPages] = useState(null);
  const handleNavigate = userId => {
    GlobalState.dispatch(push(`/searchUsers/devicesUnderUser/${userId}`));
  };
  const handleSearch = async () => {
    const filtered = await getUserByEmail(searchInput);
    setUserData(filtered);
  };
  const columns = [{
    id: 'email',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Email"
    }),
    Cell: x => /*#__PURE__*/_jsx(Button, {
      variant: "link",
      className: "lev-button lev-sc-button-link lev-sc-button-linkTable",
      onClick: () => handleNavigate(x.cell.row.original.userId),
      children: x.cell.row.original.email
    })
  }, {
    id: 'username',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Username"
    }),
    accessor: 'username',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'name',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Name"
    }),
    accessor: 'name',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'lastLogin',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Last Login"
    }),
    accessor: 'lastLogin',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }, {
    id: 'created',
    Header: () => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: "Created"
    }),
    accessor: 'created',
    Cell: props => /*#__PURE__*/_jsx("div", {
      className: S.tableCell,
      children: props.value
    })
  }];
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await getAllSystemUsers(pageSize, currentPage + 1);
        if (data) {
          const users = data.items?.map(user => ({
            email: user.email,
            name: user.name,
            username: user.username || user.id,
            created: formatUnixTimeStamp(user.created),
            lastLogin: formatUnixTimeStamp(user.lastLogin),
            lastVerify: formatUnixTimeStamp(user.lastVerify),
            userId: user.id
          }));
          setUserData(users);
          const totalUsers = data.total;
          setPages(Math.ceil(totalUsers / pageSize));
        }
      } catch (error) {
        console.error('Error fetching data', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, pageSize]);
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: "screenTitle",
        title: "Search Users",
        icon: "fa-solid fa-users",
        className: S.titleBarContainer,
        children: /*#__PURE__*/_jsxs("div", {
          className: S.searchContainer,
          children: [/*#__PURE__*/_jsx("div", {
            className: S.searchSpace
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "screenTitle",
            className: S.searchFlexContainer,
            children: [/*#__PURE__*/_jsx(TextInput, {
              placeHolder: "search by email",
              value: searchInput,
              onChange: e => setSearchInput(e.value),
              variant: "formInput",
              className: S.searchInput
            }), /*#__PURE__*/_jsx(Button, {
              variant: "secondary",
              onClick: handleSearch,
              children: "Search"
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(TableV2, {
        variant: "dataTable",
        data: userData,
        columns: columns,
        loading: loading,
        paginate: true,
        FooterComponent: () => /*#__PURE__*/_jsx(TableFooter, {
          pageIndex: currentPage,
          pageSize: pageSize,
          canNextPage: currentPage < pages - 1,
          canPreviousPage: currentPage > 0,
          setPageSize: size => {
            setPageSize(size);
            setCurrentPage(0);
          },
          gotoPage: newPageIndex => setCurrentPage(newPageIndex)
        })
      })
    })]
  });
}
export default SearchUsersScreen;